import { render, staticRenderFns } from "./Editor3.vue?vue&type=template&id=b35296c6"
import script from "./Editor3.vue?vue&type=script&lang=js"
export * from "./Editor3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports